{"id":"ProductDetail.Info.Coupon","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Coupon","options":"options:*"}]}}}